<template>
<div style="height:100%;width: 100%">
  <div style="height: 40px;width: 500px;float: right;margin-top: -52px;">
    <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels range-separator="至" class="datePicker-query"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 360px">
    </el-date-picker>
    <el-button type="primary" @click="getSleepData">查询</el-button>
  </div>
  <div style="clear: both"></div>
  <div style="height: 530px;margin: 0 20px;overflow-y: auto">
    <div style="height:100%;width: 100%" ref="sleepWrap"></div>
  </div>
</div>
</template>

<script>
import {querysleephistory, querysleepstatushistory} from '../../../api/yanglaoyuan'

export default {
  name: 'sleepHistory',
  props: {
    healthObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      personHealthRow: '',
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      sleepdata: [],
      dataX: [],
      dataY1: [],
      dataY2: [],
      inBed: []
    }
  },
  created () {
    this.personHealthRow = this.healthObj.personHealthRow // 老人最新数据
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-1)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
  },
  mounted () {
    let moduletag = this.$store.state.user.moduletag
    if (moduletag === 2) {
      this.getSleepData()
    } else {
      this.getSleepReportData()
    }
  },
  methods: {
    getSleepData () {
      let data = {
        'pid': this.personHealthRow.epid === '' ? 0 : this.personHealthRow.epid,
        'from': this.sendDate[0] + ' 00:00:00',
        'to': this.sendDate[1] + ' 23:59:59'
      }
      let params = {
        page: 1,
        size: 99999
      }
      querysleephistory(params, data).then(res => {
        this.sleepdata = res.data.sleepdata
        this.getDataEnd()
      }).catch(() => {})
    },
    getSleepReportData () {
      let data = {
        did: [],
        pid: this.personHealthRow.pid === '' ? 0 : this.personHealthRow.pid,
        'from': this.sendDate[0] + ' 00:00:00',
        'to': this.sendDate[1] + ' 23:59:59'
      }
      querysleepstatushistory(data).then(res => {
        if (res.data.sleepData.length > 0) {
          this.sleepdata = res.data.sleepData
        } else {
          this.sleepdata = []
        }
        this.getDataEnd()
      }).catch(() => {})
    },
    getDataEnd () {
      this.dataX = []
      this.dataY1 = []
      this.dataY2 = []
      let showBed = [[]]
      for (let i = 0; i < this.sleepdata.length; i++) {
        let item = this.sleepdata[i]
        this.dataX.push(item.time)
        if (item.breathe === 0) {
          this.dataY1.push('')
        } else {
          this.dataY1.push(item.breathe)
        }
        if (item.heartbeat === 0) {
          this.dataY2.push('')
        } else {
          this.dataY2.push(item.heartbeat)
        }
        if (i === 0) {
          if (item.inbed === 1) {
            let obj = {
              name: '在床',
              xAxis: item.time
            }
            showBed[0].push(obj)
          } else {
            showBed = []
          }
        } else {
          if (item.inbed === 1 && this.sleepdata[i - 1].inbed === 1) {
            let obj = {
              name: '在床',
              xAxis: item.time
            }
            showBed[showBed.length - 1].push(obj)
          } else if (item.inbed === 1 && this.sleepdata[i - 1].inbed === 0) {
            let obj = {
              name: '在床',
              xAxis: item.time
            }
            showBed.push([obj])
          }
        }
      }
      let endBend = []
      showBed.forEach(item => {
        if (item.length > 1) {
          let bed = []
          bed.push(item[0])
          bed.push(item[item.length - 1])
          endBend.push(bed)
        }
      })
      this.inBed = endBend
      this.getChartLines()
    },
    getChartLines () {
      console.log(this.dataX)
      console.log('inBed', this.inBed)
      console.log(this.dataY1)
      console.log(this.dataY2)
      let chart = this.$echarts.init(this.$refs.sleepWrap)
      let vm = this
      chart.setOption({
        legend: { data: ['呼吸', '心率'], textStyle: { color: '#ffffff' } },
        grid: [{ right: '5%', top: '10%', bottom: '15%' }],
        tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#34B8FF',
              width: 1
            }
          },
          data: vm.dataX
        },
        yAxis: {
          splitLine: { // 修改背景线条样式
            show: true, // 是否展示
            lineStyle: {
              color: '#34B8FF' // 线条颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: '#34B8FF',
              width: 1 // 这里是为了突出显示加上的
            }
          },
          type: 'value'
        },
        series: [
          {
            name: '呼吸',
            type: 'line',
            // smooth: true,
            data: vm.dataY1,
            markArea: {
              itemStyle: {
                color: 'rgba(0,45,192,0.3)'
              },
              textStyle: { color: '#ffffff' },
              data: vm.inBed
            }
          },
          {
            name: '心率',
            type: 'line',
            // smooth: true,
            data: vm.dataY2
          }
        ],
        color: ['#d2ab27', '#27cb7c']
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/sleepHistory.vue